




























import { windowHelper } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { getGapDays } from '@/util/dateHelper';
import moment from 'moment';
import { DescTimeType } from '@/types/index';
import { HotOffer } from '@/types/home-newest';
import { defineComponent, PropType, computed } from '@vue/composition-api';
import { addImgInfo } from '../img-monitor';
import { LanuchWeapp } from '@tencent/wphk-components-launch-weapp';
import { isShowMiniapp } from '@/business/miniapp';

export default defineComponent({
  name: 'HotOfferItem',
  props: {
    item: {
      type: Object as PropType<HotOffer>,
      required: true,
    },
  },
  components: {
    LanuchWeapp,
  },
  setup(props) {
    const biExt = computed(() => props.item.reportInfo);
    const isNew = computed(() => {
      const now = getServerTime();
      const start = props.item.startTime;
      let days = getGapDays(start, now);
      days = Math.ceil(days);
      // isNew 活动开始时间后7天内在Banner右上角显示【新】标识，7天后消失
      return days > 0 && days <= 7;
    });
    const desc = computed(() => {
      const time = props.item.descTimeType === DescTimeType.Start ? props.item.startTime : props.item.endTime;
      const timeStr = moment(time).format('YYYY.M.D');
      const txt = props.item.descTimeType === DescTimeType.Start ? i18n('開始') : i18n('截止');
      return `${timeStr}${txt}`;
    });

    const onImageLoad = (href: string) => {
      const endTime = performance.now();
      addImgInfo({
        href,
        endTime,
      });
    }

    return {
      biExt,
      isNew,
      desc,
      onImageLoad,
      goAct() {
        windowHelper.redirect(props.item.url, 300);
      },
      isShowMiniapp,
    };
  },
});
